import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCRUD, CRUDService, ExceptionService, UtilsService } from '../../xform-compat';
import {MyHistory} from '../../shared/models/my-history.model';


/**
 * Data service for the CRUD of My Companies
 */
@Injectable({
  providedIn: 'root'
})
export class MyHistoryService extends AbstractCRUD<MyHistory> implements CRUDService<MyHistory> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath(): string {
    return '/measures/eventlogs';
  }
}
